var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bag-out-shipment"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('fieldset', [_c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), _c('legend', [_vm._v("Bag Out Shipments")]), _vm._v(" "), _c('b-card', [_c('fieldset', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Bag No")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-archive'></i>"
    }
  }, [_c('input', _vm._b({
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.bagno),
      expression: "bagno"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('BagNo')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Bag No",
      "name": "BagNo",
      "id": "BagNo"
    },
    domProps: {
      "value": (_vm.bagno)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.bagno = $event.target.value
      }
    }
  }, 'input', _vm.colorCodeClassIcon(_vm.colorCodeBag, _vm.colorIconBag), false))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('BagNo')),
      expression: "errors.has('BagNo')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('BagNo')))])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "29px"
    }
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.searchBag
    }
  }, [_vm._v("Search Bag")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")]), _vm._v("  \n                    "), _c('button', {
    staticClass: "common-success-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.getShipmentDetails
    }
  }, [_vm._v("Show Shipment Bag Out List")])])])]), _vm._v(" "), (_vm.ConfirmBagOutUser == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Are You Sure"
    },
    model: {
      value: (_vm.ConfirmBagOutUser),
      callback: function($$v) {
        _vm.ConfirmBagOutUser = $$v
      },
      expression: "ConfirmBagOutUser"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseBagConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.ReturnMessagePrompt))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.changeBagUser
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseBagConfirmation
    }
  }, [_vm._v("Cancel")])])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.showBagData == true) ? _c('div', {
    staticClass: "col-md-12"
  }, [_c('fieldset', [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag No")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Origin")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Status")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Bag Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Scanned / Total Shipments")]), _vm._v(" "), (_vm.dtoFlag) ? _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Shipments stickered")]) : _vm._e()])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listBagSearchdata), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagno))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.originhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagstatus))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.destinationhubname))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.bagtype))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.scannedShipmentCount) + " / " + _vm._s(data.totalshipmentsinbag))]), _vm._v(" "), (_vm.dtoFlag) ? _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.isstickerprintdone))]) : _vm._e()])
  }), _vm._v(" "), ((_vm.listBagSearchdata && _vm.listBagSearchdata.length == 0) || _vm.listBagSearchdata.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])])]) : _vm._e()]), _vm._v(" "), (_vm.AutoBagOut) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4 checkbox",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkAutoBagOutShipment),
      expression: "checkAutoBagOutShipment"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkAutoBagOutShipment",
      "value": "checkAutoBagOutShipment"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkAutoBagOutShipment) ? _vm._i(_vm.checkAutoBagOutShipment, "checkAutoBagOutShipment") > -1 : (_vm.checkAutoBagOutShipment)
    },
    on: {
      "click": function($event) {
        _vm.disableAutoBagOutBtn = (_vm.disableAutoBagOutBtn + 1) % 2
      },
      "change": function($event) {
        var $$a = _vm.checkAutoBagOutShipment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkAutoBagOutShipment",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkAutoBagOutShipment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkAutoBagOutShipment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkAutoBagOutShipment = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _vm._v(" "), _c('b-button', {
    staticClass: "-common-secondary",
    attrs: {
      "type": "submit",
      "size": "sm",
      "disabled": _vm.disableAutoBagOutBtn == 1 ? false : true
    },
    on: {
      "click": _vm.autoBagOutShipment
    }
  }, [_vm._v("AutoBagOutShipment")])], 1)]) : _vm._e()], 1), _vm._v(" "), _c('fieldset', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmitShipment.apply(null, arguments)
      }
    }
  }, [(_vm.showBagData == true) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('b-form-fieldset', [_c('label', [_vm._v("Shipment ID/Bag No:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.shipmentidwithoutsecuritypatch),
      expression: "shipmentidwithoutsecuritypatch"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    ref: "ship",
    class: {
      'form-control': true, 'error': _vm.errors.has('ShipmentID')
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter ShipmentID/BagNo",
      "name": "ShipmentID",
      "id": "ShipmentID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.shipmentidwithoutsecuritypatch)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.BagOutScanSipment.apply(null, arguments)
      },
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.shipmentidwithoutsecuritypatch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "gray",
      "font-size": "12px"
    }
  }, [_vm._v("Use comma for multiple ShipmentID/BagNo's")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ShipmentID')),
      expression: "errors.has('ShipmentID')"
    }],
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('ShipmentID')))])], 1), _vm._v(" "), (_vm.showIconInput) ? _c('b-form-fieldset', [_c('b-input-group', _vm._b({}, 'b-input-group', _vm.colorCodeClassIcon(_vm.colorCode, _vm.colorIcon), false), [_vm._v(_vm._s(_vm.shipmentForColor))])], 1) : _vm._e(), _vm._v(" "), (_vm.isDTOFlyer) ? _c('b-form-fieldset', [_c('label', [_vm._v("Flyer/Package ID:")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='\tfa fa-truck'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.flyerID),
      expression: "flyerID"
    }],
    ref: "flyer",
    class: {
      'form-control': true
    },
    attrs: {
      "type": "text",
      "placeholder": "Enter Flyer/Package ID",
      "name": "flyerID",
      "id": "flyerID",
      "autocomplete": "off"
    },
    domProps: {
      "value": (_vm.flyerID)
    },
    on: {
      "keydown": function($event) {
        return _vm.restrictManualTyping($event)
      },
      "keypress": function($event) {
        return _vm.checkBarcode($event)
      },
      "dragstart": function($event) {
        $event.preventDefault();
      },
      "drop": function($event) {
        $event.preventDefault();
      },
      "cut": function($event) {
        $event.preventDefault();
      },
      "paste": function($event) {
        $event.preventDefault();
      },
      "copy": function($event) {
        $event.preventDefault();
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.flyerID = $event.target.value
      }
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "margin-top": "43px"
    }
  }, [_c('b-form-fieldset', [_c('label'), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "margin-top": "-34px"
    }
  }, [_c('button', {
    staticClass: "-common-success",
    attrs: {
      "type": "submit",
      "size": "sm"
    }
  }, [_vm._v("Bag Out Scan")]), _vm._v("  \n                    ")])], 1), _vm._v(" "), _c('b-form-fieldset', [_c('b-input-group', [(_vm.restrictionConfig.isIRTUserExceptionLoc) ? _c('button', {
    staticClass: "common-warning",
    attrs: {
      "type": "button",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.exceptionModal = true, _vm.Trackingno = ''
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-warning"
  }), _vm._v("  Capture Exception")]) : _vm._e()])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [(_vm.BagOutShipmentlist.length > 0) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-left": "16px",
      "width": "1032px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("ParentBagNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("ShippingID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("RouteID")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sub Cluster Name")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.BagOutShipmentlist), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ParentBagNo))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.RouteID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('strong', {
      style: (("color:" + (data.colorcode)))
    }, [_vm._v(_vm._s(data.PDD))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.SubClusterName))])])
  }), _vm._v(" "), ((_vm.BagOutShipmentlist && _vm.BagOutShipmentlist.length == 0) || _vm.BagOutShipmentlist.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])])]) : _vm._e()]), _vm._v(" "), (_vm.shortagemarkflag == true && _vm.isLinearFlowEnabledShipmentFlag == true && _vm.AutoBagOut == false) ? _c('div', {
    staticClass: "col-md-4 checkbox",
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "1em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkTallyBagShipment),
      expression: "checkTallyBagShipment"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkTallyBagShipment",
      "value": "checkTallyBag"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkTallyBagShipment) ? _vm._i(_vm.checkTallyBagShipment, "checkTallyBag") > -1 : (_vm.checkTallyBagShipment)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.checkTallyBagShipment,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "checkTallyBag",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkTallyBagShipment = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkTallyBagShipment = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkTallyBagShipment = $$c
        }
      }, function($event) {
        _vm.disableTallyBtn = (_vm.disableTallyBtn + 1) % 2
      }]
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "cr"
  }, [_c('i', {
    staticClass: "cr-icon fa fa-check"
  })])]), _vm._v(" "), _c('b-button', {
    staticClass: "-common-success-btn-btn",
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "button",
      "size": "sm",
      "disabled": _vm.disableTallyBtn == 1 ? false : true
    },
    on: {
      "click": _vm.getBaggedShipmentList
    }
  }, [_vm._v("Mark Shortage")])], 1) : _vm._e()]) : _vm._e()]), _vm._v(" "), (_vm.showshipmentList) ? _c('div', [_c('div', {
    staticClass: "card-headerfrm"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-9"
  }, [_c('h4', {
    staticClass: "header"
  }, [_c('i', {
    staticClass: "fa fa-bars barcolor",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Shipment Bag Out List")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('b', {
    staticStyle: {
      "float": "right",
      "color": "green"
    }
  }, [_vm._v("Total Records:" + _vm._s(_vm.totalRecords))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('fieldset', {
    staticStyle: {
      "margin-left": "0px",
      "width": "1032px"
    }
  }, [_c('div', {
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered mytable12 poform_tableheader",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center"
  }, [_vm._v("ShippingRefNo")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Volumetric Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Physical Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Chargeable Weight")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Origin Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Destination Hub")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("EDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("PDD")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Sub Cluster Name")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.ShipmentDetails), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PackageDetails.Weight.VolWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PackageDetails.Weight.PhyWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.PackageDetails.Weight.BillableWeight))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.OriginHubID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.FinalDestinationID))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.EDD))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "font-size": "16px"
      }
    }, [_c('strong', {
      style: (("color:" + (data.pddColor)))
    }, [_vm._v(_vm._s(data.pddDate))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(data.SubClusterName))])])
  }), _vm._v(" "), ((_vm.ShipmentDetails && _vm.ShipmentDetails.length == 0) || _vm.ShipmentDetails.length == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "10",
      "align": "center"
    }
  }, [_vm._v("No Record found")])]) : _vm._e()], 2)])])])]), _c('br')])]) : _vm._e()]), _vm._v(" "), (_vm.shippingIdList.length > 0) ? _c('b-modal', {
    attrs: {
      "id": "#confirmationmodal",
      "title": "Confirmation"
    },
    model: {
      value: (_vm.modalShow),
      callback: function($$v) {
        _vm.modalShow = $$v
      },
      expression: "modalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h5', {
    staticClass: "modal-title"
  }, [_vm._v("List of shipments that will be marked shortage")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.modalShow = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Sr No.")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "60%"
    }
  }, [_vm._v("Shipping ID ( " + _vm._s(_vm.shippingIdList.length) + " )")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("Action")])])])]), _vm._v(" "), _c('div', {
    style: (_vm.shippingIdList.length > 10 ? 'overflow: auto; height: 292px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', _vm._l((_vm.shippingIdList), function(data, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      staticStyle: {
        "width": "60%"
      }
    }, [_vm._v(_vm._s(data.shippingid))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      staticClass: "badge badge-success",
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          return _vm.ConfirmShipmentShortageMark(data.shippingid)
        }
      }
    }, [_vm._v("Mark Shortage")])])])
  }), 0)])])])])]) : _vm._e(), _vm._v(" "), (_vm.ConfirmShipmentShortage == true) ? _c('b-modal', {
    attrs: {
      "size": "md",
      "title": "Are You Sure"
    },
    model: {
      value: (_vm.ConfirmShipmentShortage),
      callback: function($$v) {
        _vm.ConfirmShipmentShortage = $$v
      },
      expression: "ConfirmShipmentShortage"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingSearch
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingSearch = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v("Are you sure you want to mark this item as shortage?")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm"
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.MarkShipmentShortage(_vm.shortageShipmentDetails)
      }
    }
  }, [_vm._v("Confirm")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.CloseConfirmation
    }
  }, [_vm._v("Cancel")])])])])], 1) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "no-close-on-backdrop": _vm.isSysExcp,
      "no-close-on-esc": _vm.isSysExcp,
      "hide-footer": "",
      "centered": "",
      "modal-class": "exception-modal",
      "size": "md"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('div', {
          staticClass: "ex-header ex-divider"
        }, [_c('div', {
          staticClass: "ex-title"
        }, [_c('span', {
          staticClass: "warn"
        }, [_c('i', {
          staticClass: "fa fa-warning"
        })]), _c('span', [_vm._v("Capture Exception")]), _vm._v(" "), (_vm.isSysExcp) ? _c('span', {
          staticClass: "ex-badge"
        }, [_vm._v("Exception ID #" + _vm._s(_vm.Trackingno))]) : _vm._e()]), _vm._v(" "), (!_vm.isSysExcp) ? _c('button', {
          staticClass: "close exheader-close",
          attrs: {
            "type": "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            "click": function($event) {
              return _vm.resetIRTParams()
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])]) : _vm._e()])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.exceptionModal),
      callback: function($$v) {
        _vm.exceptionModal = $$v
      },
      expression: "exceptionModal"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.exLoading
    },
    on: {
      "update:active": function($event) {
        _vm.exLoading = $event
      }
    }
  }), _vm._v(" "), _vm._v(" "), _c('div', {
    staticClass: "ex-info"
  }, [_c('span', {
    staticClass: "info-icon"
  }, [_c('i', {
    staticClass: "fa fa-info-circle"
  })]), _c('span', [_vm._v("Provide details regarding the shipment exception for records and follow-up.")])]), _vm._v(" "), _c('div', {
    staticClass: "ex-body"
  }, [_c('label', [_vm._v("AWB Number / Flyer ID / Bag Seal ID")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionAWB),
      expression: "exceptionAWB"
    }],
    staticClass: "ex-input",
    attrs: {
      "placeholder": "Enter or Scan AWB / Flyer / Bag ID",
      "disabled": _vm.isSysExcp
    },
    domProps: {
      "value": (_vm.exceptionAWB)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exceptionAWB = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Error / Exception Message "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionError),
      expression: "exceptionError"
    }],
    staticClass: "ex-input",
    attrs: {
      "placeholder": "Enter Error / Exception Message",
      "disabled": _vm.isSysExcp
    },
    domProps: {
      "value": (_vm.exceptionError)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exceptionError = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excErr),
      expression: "excErr"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.excErr))]), _vm._v(" "), _c('label', [_vm._v("Exception Type "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionType),
      expression: "exceptionType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "ex-input",
    attrs: {
      "disabled": _vm.isSysExcp,
      "name": "Select Exception Type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.exceptionType = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Select Exception Type")]), _vm._v(" "), _vm._l((_vm.exceptionTypeList), function(exceptionT) {
    return _c('option', {
      domProps: {
        "value": exceptionT.value
      }
    }, [_vm._v(_vm._s(exceptionT.text))])
  })], 2), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.excTypErr),
      expression: "excTypErr"
    }],
    staticClass: "text-danger",
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.excTypErr))]), _vm._v(" "), _c('label', [_vm._v("Comments / Additional Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exceptionComment),
      expression: "exceptionComment"
    }],
    staticClass: "ex-input",
    attrs: {
      "rows": "4",
      "max-rows": "10",
      "cols": "50",
      "placeholder": "Describe the exception in detail..."
    },
    domProps: {
      "value": (_vm.exceptionComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exceptionComment = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isSysExcp) ? _c('div', {
    staticClass: "ex-footer ex-divider-top"
  }, [_c('button', {
    staticClass: "ex-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.raiseException()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v("Update Exception")])]) : _c('div', {
    staticClass: "ex-footer ex-divider-top"
  }, [_c('button', {
    staticClass: "ex-btn-trans",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.resetIRTParams()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "ex-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.raiseException()
      }
    }
  }, [_vm._v("Submit Exception")])])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "hide-footer": "",
      "centered": "",
      "modal-class": "success-modal"
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function() {
        return [_c('div', {
          staticClass: "success-header"
        }, [_c('div', {
          staticClass: "header-left"
        }, [_c('i', {
          staticClass: "fa fa-check-circle"
        }), _c('span', [_vm._v("SUCCESS CONFIRMATION")])]), _vm._v(" "), _c('button', {
          staticClass: "close header-close",
          attrs: {
            "type": "button",
            "data-dismiss": "modal",
            "aria-label": "Close"
          },
          on: {
            "click": function($event) {
              return _vm.resetIRTParams()
            }
          }
        }, [_c('span', {
          attrs: {
            "aria-hidden": "true"
          }
        }, [_vm._v("×")])])])]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.exSuccModal),
      callback: function($$v) {
        _vm.exSuccModal = $$v
      },
      expression: "exSuccModal"
    }
  }, [_vm._v(" "), _c('div', {
    staticClass: "success-body"
  }, [_c('div', {
    staticClass: "check-circle"
  }, [_c('i', {
    staticClass: "fa fa-check"
  })]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.logMessage))]), _vm._v(" "), _c('p', {
    staticClass: "sub-text"
  }, [_vm._v("Generated Exception ID")]), _vm._v(" "), _c('div', {
    staticClass: "id-box"
  }, [_vm._v("# " + _vm._s(_vm.Trackingno))]), _vm._v(" "), _c('div', {
    staticClass: "bottom-handle"
  })])])], 1)], 1), _vm._v(" "), (_vm.BagOutShipmentData.sortCode || _vm.BagOutShipmentData.ServiceType) ? _c('div', {
    staticClass: "card-body1"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-10"
  }, [_c('b-card', [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [(_vm.BagOutShipmentData.sortCode) ? _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("Sort Code")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("Service Type")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("Group Detail")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("MOT")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("Zone")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v("Total Pending Shipments")])])]), _vm._v(" "), _c('tbody', [_c('tr', [(_vm.BagOutShipmentData.sortCode) ? _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.sortCode))]) : _vm._e(), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.ServiceType))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.GroupDetail))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.mot))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.Zone))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.Destination))]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "font-size": "100%",
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.BagOutShipmentData.PendingCount))])])])])])], 1)])]) : _vm._e()]), _vm._v(" "), (_vm.Weighingrequired !== null) ? _c('b-input-group', {
    staticClass: "d-flex align-items-center p-2 rounded"
  }, [_c('strong', {
    staticClass: "label-text"
  }, [_vm._v("Weighing Required:")]), _vm._v(" "), (!_vm.Weighingrequired) ? _c('span', {
    staticClass: "status-icon success"
  }, [_vm._v(" ✔")]) : _c('span', {
    staticClass: "status-icon danger"
  }, [_vm._v(" ✘")])]) : _vm._e(), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": "Confirmation"
    },
    model: {
      value: (_vm.invalidTokenModal),
      callback: function($$v) {
        _vm.invalidTokenModal = $$v
      },
      expression: "invalidTokenModal"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Confirmation")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('p', [_vm._v(_vm._s(_vm.invalidtokenmsg))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "common-success",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Logout")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.closeinvalidTokenModal
    }
  }, [_vm._v("Cancel")])])])])])], 1)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10aa3091","hasScoped":true}!./src/views/components/BagOutShipment/BagOutShipment.html
// module id = 944
// module chunks = 2